var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"comeFromTop"}},[(_vm.chatErrorMessage !== null)?_c('div',{class:_vm.$style['chat-error-header']},[_vm._v(" "+_vm._s(_vm.chatErrorMessage)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }